import { render, staticRenderFns } from "./SkillStubLink.vue?vue&type=template&id=35837ca5&scoped=true&"
import script from "./SkillStubLink.vue?vue&type=script&lang=ts&"
export * from "./SkillStubLink.vue?vue&type=script&lang=ts&"
import style0 from "./SkillStubLink.vue?vue&type=style&index=0&id=35837ca5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35837ca5",
  null
  
)

export default component.exports